import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const TERMS = [
  ["event", "Event"], ["player", "Participant"], ["zone", "Booth / Zone"], ["gamemaster", "Moderator"],
  ["xp", "Points"], ["leaderboard", "Leaderboard"], ["rewards", "Prize area"],
];
const THEMES = ["#FF3B30", "#007AFF", "#34C759", "#FFCC00", "#AF52DE", "#FF2D55"];

export default function Settings({ event, slug, refresh }) {
  const [t, setT] = useState({ ...(event.terminology || {}) });
  const [theme, setTheme] = useState(event.theme);
  const [basics, setBasics] = useState({ name: event.name, location: event.location || "", date: event.date || "", cover_image_url: event.cover_image_url || "" });

  const saveTerms = async () => { await api.put(`/events/${slug}`, { terminology: t }); toast.success("Terminology saved"); refresh(); };
  const saveTheme = async (c) => { setTheme(c); await api.put(`/events/${slug}`, { theme: c }); refresh(); };
  const saveBasics = async () => { await api.put(`/events/${slug}`, basics); toast.success("Saved"); refresh(); };
  const toggleLB = async (v) => { await api.put(`/events/${slug}`, { leaderboard_visible: v }); refresh(); };

  return (
    <div className="max-w-2xl space-y-8">
      <h1 className="font-head font-black text-2xl">Customize your Arena</h1>

      <section className="brut p-6">
        <h2 className="font-head font-bold text-lg mb-4">Basics</h2>
        <div className="space-y-3">
          <div><Label className="mb-1 block">Arena name</Label><Input value={basics.name} onChange={(e) => setBasics({ ...basics, name: e.target.value })} data-testid="set-name" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="mb-1 block">Date</Label><Input type="date" value={basics.date} onChange={(e) => setBasics({ ...basics, date: e.target.value })} /></div>
            <div><Label className="mb-1 block">Location</Label><Input value={basics.location} onChange={(e) => setBasics({ ...basics, location: e.target.value })} /></div>
          </div>
          <div><Label className="mb-1 block">Cover image URL</Label><Input value={basics.cover_image_url} onChange={(e) => setBasics({ ...basics, cover_image_url: e.target.value })} /></div>
          <Button className="rounded-full font-bold" onClick={saveBasics} data-testid="save-basics">Save basics</Button>
        </div>
      </section>

      <section className="brut p-6">
        <h2 className="font-head font-bold text-lg mb-1">Theme colour</h2>
        <p className="text-xs text-muted-foreground mb-4">Applied across Player Arena and Big Screen.</p>
        <div className="flex gap-3">
          {THEMES.map((c) => <button key={c} onClick={() => saveTheme(c)} style={{ background: c }} className={`w-9 h-9 rounded-full border-2 ${theme === c ? "ring-2 ring-offset-2 ring-offset-background ring-white border-white" : "border-neutral-300"}`} data-testid={`set-theme-${c}`} />)}
        </div>
      </section>

      <section className="brut p-6">
        <h2 className="font-head font-bold text-lg mb-1">Custom terminology</h2>
        <p className="text-xs text-muted-foreground mb-4">Rename anything to fit your crowd (e.g. Players → Students, Cash → Points).</p>
        <div className="grid sm:grid-cols-2 gap-3">
          {TERMS.map(([k, l]) => (
            <div key={k}><Label className="mb-1 block text-xs text-muted-foreground">{l}</Label><Input value={t[k] || ""} onChange={(e) => setT({ ...t, [k]: e.target.value })} data-testid={`term-${k}`} /></div>
          ))}
        </div>
        <Button className="rounded-full font-bold mt-4" onClick={saveTerms} data-testid="save-terms">Save terminology</Button>
      </section>

      <section className="brut p-6 flex items-center justify-between">
        <div><h2 className="font-head font-bold text-lg">Leaderboard visibility</h2><p className="text-xs text-muted-foreground">Show the Hall of Fame to players.</p></div>
        <Switch checked={event.leaderboard_visible} onCheckedChange={toggleLB} data-testid="lb-toggle" />
      </section>
    </div>
  );
}
